export default "__VITE_ASSET__063c4bfb__"